import BrandMark from '../components/BrandMark';
import React, { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { authAPI } from '../services/api';
import { useAuth } from '../hooks/useAuth';
import { UserPlus } from 'lucide-react';
import toast from 'react-hot-toast';

export default function InvitePage() {
  const { token } = useParams();
  const navigate = useNavigate();
  const { login } = useAuth();
  const [form, setForm] = useState({ email: '', password: '', name: '' });
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await authAPI.acceptInvite({ token, email: form.email, password: form.password, name: form.name });
      toast.success('Регистрация успешна!');
      setDone(true);

      await login(form.email, form.password);
      navigate('/');
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Ошибка. Ссылка может быть недействительна.');
    }
    finally { setLoading(false); }
  };

  return (
    <div style={{
      minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
      background: 'var(--bg-primary)',
    }}>
      <div style={{
        width: 400, padding: 36, borderRadius: 'var(--radius)',
        background: 'var(--bg-card)', border: '1px solid var(--border)',
      }}>
        <div style={{ textAlign: 'center', marginBottom: 28 }}>
          <BrandMark size={42} style={{ color: 'var(--accent)', marginBottom: 12 }} />
          <h1 style={{ fontSize: 20, fontWeight: 700, marginBottom: 4 }}>Присоединяйтесь</h1>
          <p style={{ fontSize: 13, color: 'var(--text-muted)' }}>Вас пригласили в SEGMIRA</p>
        </div>

        {done ? (
          <div style={{ textAlign: 'center', color: 'var(--success)', padding: 20 }}>
            Вы успешно зарегистрированы! Перенаправление...
          </div>
        ) : (
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label className="form-label">Имя</label>
              <input className="form-input" placeholder="Ваше имя"
                value={form.name} onChange={e => setForm({ ...form, name: e.target.value })} />
            </div>
            <div className="form-group">
              <label className="form-label">Email *</label>
              <input className="form-input" type="email" required placeholder="email@example.com"
                value={form.email} onChange={e => setForm({ ...form, email: e.target.value })} />
            </div>
            <div className="form-group">
              <label className="form-label">Пароль *</label>
              <input className="form-input" type="password" required minLength={6} placeholder="Минимум 6 символов"
                value={form.password} onChange={e => setForm({ ...form, password: e.target.value })} />
            </div>
            <button type="submit" className="btn btn-primary" disabled={loading}
              style={{ width: '100%', justifyContent: 'center', marginTop: 12 }}>
              <UserPlus size={16} /> {loading ? 'Регистрация...' : 'Присоединиться'}
            </button>
          </form>
        )}
      </div>
    </div>
  );
}